import {SportstypeSpec} from "../types";
import start from "../../icons/motoball/start";
import end from "../../icons/motoball/end";
import corner from "../../icons/motoball/corner";
import goal from "../../icons/motoball/goal";
import greenCard from "../../icons/motoball/green-card";
import redCard from "../../icons/motoball/red-card";
import substitution from "../../icons/motoball/substitution";
import substituteOut from '../../icons/_shared/substitute-out'
import substituteIn from '../../icons/_shared/substitute-in'
import yellowCard from "../../icons/motoball/yellow-card";
import yellowRedCard from "../../icons/motoball/yellow-red-card";
import penalty from '../../icons/motoball/penalty';
import freeKick from "../../icons/motoball/free-kick";
import main from "../../icons/motoball/main";
import { initializeTeamGameScoreboard, scoreChange } from "../eventHandlerUtils";

const motoball: SportstypeSpec = {
  id: 'motoball',
  scoreboardType: 'team-game-scoreboard',
  svg: main,
  releaseStage: 'alpha',
  displayPhaseOvertimeFormat: 'extra-time',
  phases: ['pregame', 'halves', 'extra-time', 'postgame'],
  events: [
    {
      id: 'start',
      important: true,
      svg: start,
      eventHandler: initializeTeamGameScoreboard
    },
    {
      id: 'end',
      important: true,
      svg: end
    },
    {
      id: 'corner',
      important: true,
      svg: corner,
      team: "any"
    },
    {
      id: 'goal',
      important: true,
      svg: goal,
      team: 'any',
      eventHandler: scoreChange(1),
      players: [
        {id: 'scorer'}
      ]
    },
    {
      id: 'green-card',
      important: true,
      svg: greenCard,
      players: [
        {id: "offender"}
      ]
    },
    {
      id: 'yellow-card',
      important: true,
      svg: yellowCard,
      players: [
        {id: "offender"}
      ]
    },
    {
      id: 'yellow-red-card',
      important: true,
      svg: yellowRedCard,
      players: [
        {id: "offender"}
      ]
    },
    {
      id: 'red-card',
      important: true,
      svg: redCard,
      players: [
        {id: "offender"}
      ]
    },
    {
      id: 'penalty',
      important: true,
      svg: penalty,
      players: [
        {id: "shooter"}
      ]
    },
    {
      id: 'free-kick',
      important: true,
      svg: freeKick,
      players: [
        {id: "shooter"}
      ]
    },
    {
      id: 'substitution',
      important: true,
      svg: substitution,
      players: [
        {id: "in", svg: substituteIn},
        {id: "out", svg: substituteOut}
      ]
    },
  ]
}

export default motoball
